import React from 'react'
import { Grid } from "@mui/material";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import UiTableHead from '../../../_uiMocks/_uiComponents/UiTableHead'
import UiCheckbox from '../../../_uiComponents/common/form/UiCheckBox';
import UiSelect from "../../../_uiMocks/_uiComponents/UiSelect";
import UiDropZoneUploader from '../../../_uiComponents/common/form/UiDropZoneUploader'
import UiDropdownButton from '../../../_uiComponents/common/form/UiDropdownButton';
import { UploadStatus } from '../../../_uiComponents/common/DataGridComponents'
import JsonViewDataTable from './JsonViewDataTable';


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


export default function DataUpload(props) {

    const [open, setOpen] = React.useState(false);
    const [value, setValue] = React.useState('success');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(8);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState();
    const [checked, setChecked] = React.useState([false, false, false]);
    const [active, setActive] = React.useState();

    const handleSummary = () => {
        setOpen(!open);
    };

    const [contains, setContains] = React.useState('');

    const handleContainChange = (event) => {
        setContains(event.target.value);
    };

    //Dropdown Button
    const dropdownOptions = ['Process Summary', 'Process Failed'];

    const handleBtnClick = (item) => {
        console.log(item)
    }

    const options = [
        { value: 'value-1', label: 'text-1' },
        { value: 'value-2', label: 'text-2' },
        { value: 'value-3', label: 'text-3' }
    ];

    const headings = [
        { id: 'filetemplate', name: 'File Template' },
        { id: 'type', name: 'File Type' },
        { id: 'totalrecords', name: 'Total Records' },
        { id: 'date', name: 'Date' },
        { id: 'status', name: 'Status' },
        { id: '', name: '' },
        { id: '', name: '' }
    ]
    const rows = [
        {
            id: 1,
            name: 'After sales data',
            type: 'Sales',
            totalRecords: '3500',
            date: '2024.01.10',
            status: 'completed',
        },
    ]
    //Sorting
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    //Data sorting
    const visibleRows = React.useMemo(
        () =>
            stableSort(rows, getComparator(order, orderBy)).slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage, rows],
    );
    
    const [dataUploadRecord, setDataUploadRecord] = React.useState({
        totalRecords: false,
        successRecords: false,
        failedRecords: false,
    });

    const { totalRecords, successRecords, failedRecords } = dataUploadRecord;

    const handleChange = (event) => {
        setDataUploadRecord({
            ...dataUploadRecord,
            [event.target.name]: event.target.checked,
        });

    };
    const dataRows = [
        {
            id: 1,
            name: 'Sales type 1',
            type: 'abc',
            total_records: 10,
            in_use: true,
            enable: true,
            status: 'failed',
            items: [
                {
                    id: 1,
                    name: 'Sales 01',
                    customerId: '1984510',

                },
                {
                    id: 2,
                    name: 'Sales 02',
                    customerId: 'Anonymous',

                },
            ],

        },
        {
            id: 2,
            name: 'Sales type 2',
            type: 'abc',
            total_records: 10,
            in_use: true,
            enable: true,
            status: 'failed',
            items: [
                {
                    id: 1,
                    name: 'Sales 03',
                    customerId: '1984510',

                },
                {
                    id: 2,
                    name: 'Sales 04',
                    customerId: 'Anonymous',

                },
            ],

        },
    ]

    return (
        <>
            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                <Grid item xs="12" lg="5">
                    <UiSelect label="Data Template"
                        value={contains}
                        handleChange={handleContainChange}
                        options={options} >
                    </UiSelect>
                </Grid>
                <Grid item xs="12" lg="7">
                    <UiDropZoneUploader />
                </Grid>
            </Grid>
            <div className='sba-table-main-wr'>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650, mt: 0 }} aria-label="simple table" className='sbt-data-grid'>
                        <UiTableHead
                            headings={headings}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort} />
                        <TableBody>
                            {visibleRows.map((row, index) => (
                                <>
                                    <TableRow>
                                        <TableCell>
                                            {row.name}
                                        </TableCell>
                                        <TableCell>
                                            {row.type}
                                        </TableCell>
                                        <TableCell>
                                            {row.totalRecords}
                                        </TableCell>
                                        <TableCell>
                                            {row.date}
                                        </TableCell>
                                        <TableCell>
                                            <Stack direction="row" spacing={1}>
                                                <UploadStatus status={row.status} />
                                            </Stack>
                                        </TableCell>
                                        <TableCell>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                onClick={handleSummary}>
                                                Summary
                                            </Button>

                                        </TableCell>
                                        <TableCell>
                                            <UiDropdownButton dropdownOptions={dropdownOptions} handleBtnClick={handleBtnClick} />
                                        </TableCell>

                                    </TableRow>
                                </>
                            ))}
                            <TableRow>
                                <TableCell style={{ paddingBottom: 0, paddingTop: 0, background: '#f9f8f8', border: 'none' }} colSpan={12}>
                                    <Collapse in={open} timeout="auto" unmountOnExit>
                                        <Box sx={{ margin: 1 }}>
                                            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                                                <Grid item xs="12" lg="4" className='sbm-summary-table-box'>
                                                    <UiCheckbox id="totalCheckbox"
                                                        checked={totalRecords} name="totalRecords"
                                                        handleChange={handleChange}
                                                    />
                                                    <label for="totalCheckbox">
                                                        <div className='sbm-records-ui sbm-total-records'>
                                                            <h3>Total Records</h3>
                                                            <span>1250</span>
                                                        </div>
                                                    </label>
                                                </Grid>
                                                <Grid item xs="12" lg="4" className='sbm-summary-table-box'>
                                                    <UiCheckbox id="successCheckbox"
                                                        checked={successRecords} name="successRecords"
                                                        handleChange={handleChange} />
                                                    <label for="successCheckbox">
                                                        <div className='sbm-records-ui sbm-success-records'>
                                                            <h3>Success Records</h3>
                                                            <span>1000</span>
                                                        </div>
                                                    </label>
                                                </Grid>
                                                <Grid item xs="12" lg="4" className='sbm-summary-table-box'>
                                                    <UiCheckbox id="failedCheckbox"
                                                        checked={failedRecords} name="failedRecords"
                                                        handleChange={handleChange}
                                                    />
                                                    <label for="failedCheckbox">
                                                        <div className='sbm-records-ui sbm-failed-records'>
                                                            <h3>Failed Records</h3>
                                                            <span>500</span>
                                                        </div>
                                                    </label>
                                                </Grid>
                                            </Grid>

                                            <JsonViewDataTable/>
                                           
                                        </Box>
                                    </Collapse>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>



        </>
    )
}
